//
// Module for Employer Schedules Index view
//
rs.module("content/employer/reporting/schedules/index",

    [ /* dependencies */],

    function () {

        // Initialize the module
        function initialize(jsSelectors) {
            var indexForm = $.js(jsSelectors.indexForm);

            indexForm.js(jsSelectors.yearSelect).change(function () {
                this.form.submit();
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);